module.exports = __webpack_public_path__ + "img/index-honor77.5cea026b.png";